import { icons } from 'lucide-react';
import React, { FC } from 'react';

type IconName = keyof typeof icons;
interface IconProps {
  name: IconName;
  size: number;
  color?: string;
}

export const Icon:FC<IconProps> = ({ name, size, color }) => {
  const LucideIcon = icons[name];
  return (<LucideIcon size={size} color={color} strokeWidth={1.7} />);
};
